import React from 'react';
import { Navigate } from 'react-router-dom';
import useUser from '../../hooks/useUser';

type Props = {
  roles: string[];
  children: React.ReactNode;
  fallbackTo?: string;
};

const RequireRole = ({ roles, children, fallbackTo = '/dashboard' }: Props) => {
  const { loading, user, role } = useUser();

  if (loading) return <div className="p-4">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(String(role))) return <Navigate to={fallbackTo} replace />;

  return <>{children}</>;
};

export default RequireRole;

